import { convertDistance } from '#helper';

const DISTANCE_DEVIATION_METERS = [50, 100, 300, 500, 1000, 2000, 5000, 10000];
export const DEFAULT_DISTANCE_DEVIATION = 100;
export const MIN_DISTANCE_DEVIATION = 0;
export const MAX_DISTANCE_DEVIATION = 10000;

const formatDistanceDeviationLabel = meters => {
  const value = Number(meters);
  if (!Number.isFinite(value)) {
    return '';
  }
  if (value >= 1000 && value % 1000 === 0) {
    return `${value / 1000}km`;
  }
  return `${value}m`;
};

export const getDistanceDeviationOptions = (currentValue, measurementSystem) => {
  const options = DISTANCE_DEVIATION_METERS.map(meters => ({
    value: convertDistance(meters, 'metric', measurementSystem),
    label: formatDistanceDeviationLabel(meters)
  }));
  const current = Number(currentValue);
  if (Number.isFinite(current) && !options.some(option => option.value === current)) {
    options.push({
      value: current,
      label: formatDistanceDeviationLabel(convertDistance(current, measurementSystem, 'metric'))
    });
    options.sort((a, b) => a.value - b.value);
  }
  return options;
};
